import { useState, useEffect } from 'react';
import Page from '../components/Page';
import image from '../static/images/Club.webp';


const Club = (props) => {

  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');




  useEffect(() => {
    fetch('./content/club-NL0.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/club-EN0.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>



  document.title = 'Programme DS - De School Amsterdam';
  const headerTitle = 'Programme DS';
  const description = 'Programme Programme Programme Programme Programme Programme  ';



  return <Page
          headerTitle={headerTitle}
          description={description}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}/>


};

export default Club;
